import { useMemo } from 'react';

import { useParams } from 'react-router';

import { ReleaseRef } from 'hooks/data/versions/types';
import { MOST_RECENT_VERSION } from 'utilities/constants/versions';

import { VersionInfoParams } from './types';

const useVersionInfo = () => {
  const { ver = MOST_RECENT_VERSION, system_model = 'cutoff' } = useParams<VersionInfoParams>();

  return useMemo(
    () => ({
      ver,
      system_model,
    }),
    [ver, system_model]
  );
};

export const useResolvedRelease = (override?: Partial<ReleaseRef>): ReleaseRef => {
  const { ver, system_model } = useVersionInfo();
  const overrideVersion = override?.version;
  const overrideSystemModel = override?.system_model;

  return useMemo(
    () => ({
      version: overrideVersion ?? ver,
      system_model: overrideSystemModel ?? system_model,
    }),
    [overrideVersion, overrideSystemModel, ver, system_model]
  );
};

export default useVersionInfo;
